import { Alert, Button, HStack, Text } from '@chakra-ui/react';
import { Modal } from '@gamma/ui/overlay';
import { i18n } from '@investigator/shared/localization';

const { entityEDR } = i18n.pages.detections;
const { edrAction } = entityEDR;

export interface ChangeStatusModalProps {
  tenant: string;
  entityId: string;
  detectionId: string;
  action: 'isolate' | 'lift_isolation';
  platform: 'Microsoft Defender' | 'CrowdStrike';
  entityName?: string;
  onClose: () => void;
  isOpen: boolean;
  // Required props - mutation handled by context
  onConfirm: () => void | Promise<void>;
  isLoading: boolean;
}

export const ChangeStatusModal = ({
  isOpen,
  onClose,
  action,
  platform,
  entityName,
  onConfirm,
  isLoading,
}: ChangeStatusModalProps) => {
  const actionCopy =
    action === 'isolate' ? edrAction.isolateEntity : edrAction.liftIsolation;

  return (
    <Modal
      size="lg"
      isOpen={isOpen}
      onClose={onClose}
      title={`${actionCopy} in ${platform}`}
      body={
        action !== 'isolate' ? (
          <Text>
            <Text as="span" textStyle="body-md-bold">
              {entityName}
            </Text>{' '}
            {edrAction.willBeAdded}
          </Text>
        ) : (
          <Alert variant="subtle" status="warning">
            <Text>
              <Text as="span" textStyle="body-md-bold">
                {entityName}
              </Text>{' '}
              {edrAction.willBeIsolated}
            </Text>
          </Alert>
        )
      }
      footer={
        <HStack>
          <Button variant="solid" colorScheme="gray" onClick={onClose}>
            {edrAction.cancel}
          </Button>
          <Button
            variant="solid"
            colorScheme="blue"
            onClick={onConfirm}
            isLoading={isLoading}
            isDisabled={isLoading}
          >
            {action !== 'isolate'
              ? edrAction.liftIsolation
              : edrAction.isolateEntity}
          </Button>
        </HStack>
      }
    />
  );
};
